var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66212 15.4563C8.90076 15.2702 9.11722 15.0537 9.55008 14.6209L15.097 9.07399C14.342 8.75978 13.4479 8.24365 12.6022 7.39801C11.7565 6.55224 11.2403 5.65794 10.9261 4.90293L5.37912 10.4499L5.3791 10.4499C4.94625 10.8828 4.72981 11.0992 4.54367 11.3379C4.3241 11.6194 4.13585 11.924 3.98226 12.2463C3.85205 12.5195 3.75526 12.8099 3.56167 13.3906L2.54084 16.4531C2.44557 16.7389 2.51995 17.054 2.73297 17.267C2.94599 17.48 3.26108 17.5544 3.54688 17.4592L6.60939 16.4383C7.19014 16.2447 7.48052 16.1479 7.75373 16.0177C8.07602 15.8641 8.38061 15.6759 8.66212 15.4563Z",
    fill: "#5F6366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6362 7.53479C17.7879 6.38301 17.7879 4.51561 16.6362 3.36383C15.4844 2.21206 13.617 2.21206 12.4652 3.36383L11.7999 4.02911C11.809 4.05662 11.8185 4.08451 11.8283 4.11277C12.0721 4.81562 12.5322 5.737 13.3977 6.60252C14.2632 7.46803 15.1846 7.92811 15.8875 8.17196C15.9156 8.18172 15.9434 8.19113 15.9708 8.2002L16.6362 7.53479Z",
    fill: "#5F6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.f8e4b720112a64527e7175ba64ddf70a.svg";
export { ForwardRef as ReactComponent };